import { render, staticRenderFns } from "./ProductApplicationTable.vue?vue&type=template&id=6130340c&lang=html&"
import script from "./ProductApplicationTable.vue?vue&type=script&lang=js&"
export * from "./ProductApplicationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports